"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResolveIdentityConflictRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class ResolveIdentityConflictRequestDto {}
exports.ResolveIdentityConflictRequestDto = ResolveIdentityConflictRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Short-lived conflict token from SSO registration telephone request'
}), __metadata("design:type", String)], ResolveIdentityConflictRequestDto.prototype, "conflictToken", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.IdentityProvider,
  description: 'How the user proves ownership of the existing account'
}), __metadata("design:type", String)], ResolveIdentityConflictRequestDto.prototype, "proofProvider", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'OTP sent to the conflicting telephone. Required when proofProvider is Telephone.'
}), __metadata("design:type", String)], ResolveIdentityConflictRequestDto.prototype, "otp", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Google or Apple ID token. Required when proofProvider is Google or Apple.'
}), __metadata("design:type", String)], ResolveIdentityConflictRequestDto.prototype, "idToken", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", String)], ResolveIdentityConflictRequestDto.prototype, "deviceToken", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", String)], ResolveIdentityConflictRequestDto.prototype, "deviceId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.UserDeviceType,
  required: false
}), __metadata("design:type", String)], ResolveIdentityConflictRequestDto.prototype, "deviceType", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], ResolveIdentityConflictRequestDto.prototype, "deviceVersion", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], ResolveIdentityConflictRequestDto.prototype, "deviceModel", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], ResolveIdentityConflictRequestDto.prototype, "appVersion", void 0);
//# sourceMappingURL=ResolveIdentityConflictRequest.dto.js.map